import { render } from "./QuestDetailPanel.vue?vue&type=template&id=5b1562b2&scoped=true"
import script from "./QuestDetailPanel.vue?vue&type=script&lang=js"
export * from "./QuestDetailPanel.vue?vue&type=script&lang=js"

import "./QuestDetailPanel.vue?vue&type=style&index=0&id=5b1562b2&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1562b2"]])

export default __exports__